import { BATTLESHIP, CALYPSO_LIGHT, OBSIDIAN } from 'HubStyleTokens/colors';
// QuickFiltersBar
export const mediumButtonProperties = {
  BUTTON_HEIGHT: 40,
  BUTTON_SIZE: 'md',
  BUTTON_USE: 'transparent',
  DRAG_HANDLE_SIZE: '400',
  LABEL_MAX_WIDTH: 120
};
export const smallButtonProperties = {
  BUTTON_HEIGHT: 32,
  BUTTON_SIZE: 'sm',
  BUTTON_USE: 'transparent',
  DRAG_HANDLE_SIZE: '300',
  LABEL_MAX_WIDTH: 80
};

// FiltersBar
export const BUTTON_SIZES = {
  sm: 'sm',
  md: 'md'
};
export const BUTTON_ACTIVE_BACKGROUND_COLOR = CALYPSO_LIGHT;
export const BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS = 'fill-info-subtle';
export const BUTTON_BORDER_COLOR = BATTLESHIP;
export const BUTTON_COLOR = OBSIDIAN;
export const BUTTONS_SPACING = 8;
export const FILTERS_BAR_LABEL_MAX_WIDTH = 260;
export const MORE_POPOVER_LABEL_MAX_WIDTH = 160;
export const defaultMediumButtonProperties = {
  BUTTON_HEIGHT: 40,
  BUTTON_SIZE: 'md',
  BUTTON_USE: 'transparent',
  DRAG_HANDLE_SIZE: '400'
};
export const defaultSmallButtonProperties = {
  BUTTON_HEIGHT: 32,
  BUTTON_SIZE: 'sm',
  BUTTON_USE: 'transparent',
  DRAG_HANDLE_SIZE: '300'
};
export const DEFAULT_BUTTON_PROPERTIES = {
  [BUTTON_SIZES.sm]: defaultSmallButtonProperties,
  [BUTTON_SIZES.md]: defaultMediumButtonProperties
};
export const getButtonPropertiesForFiltersBarAndMorePopover = defaultButtonProperties => {
  return {
    filtersBarButtonProperties: Object.assign({}, defaultButtonProperties, {
      LABEL_MAX_WIDTH: FILTERS_BAR_LABEL_MAX_WIDTH
    }),
    morePopoverButtonProperties: Object.assign({}, defaultButtonProperties, {
      LABEL_MAX_WIDTH: MORE_POPOVER_LABEL_MAX_WIDTH
    })
  };
};